import * as React from 'react';
import { SVGProps } from 'react';

const SvgProxy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M24 32v-.833a9.318 9.318 0 0 0-9.333-9.334h-2.334A9.318 9.318 0 0 0 3 31.167V32"
    />
    <path fill={props.fill} d="M25.167 32v4.667H6.333L1.667 32h23.5Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M13.5 6c-3.333 0-6 2.667-6 6v3.667c0 3.333 2.667 6 6 6s6-2.667 6-6V12c0-3.333-2.667-6-6-6Zm8.667 12 7 3.833m-7-7.5 7-3.833"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M34.667 19.167C32 19.167 30 21.333 30 23.833c0 2.667 2.167 4.667 4.667 4.667 2.666 0 4.666-2.167 4.666-4.667 0-2.666-2.166-4.666-4.666-4.666Zm.75 4.155a1.667 1.667 0 1 0-1.531-.016c-.74.284-1.22.976-1.22 1.86v2h4v-2c0-.868-.553-1.551-1.249-1.844Zm-.75-19.989C32 3.333 30 5.5 30 8c0 2.667 2.167 4.667 4.667 4.667 2.666 0 4.666-2.167 4.666-4.667s-2.166-4.667-4.666-4.667Zm.91 4.23a1.667 1.667 0 1 0-1.85-.021c-.65.318-1.06.973-1.06 1.791v2h4v-2c0-.8-.471-1.445-1.09-1.77Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgProxy;
